import script from "./BatchView.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchView.vue?vue&type=script&setup=true&lang=js"

import "./BatchView.vue?vue&type=style&index=0&id=830e4132&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-830e4132"]])

export default __exports__